const dropDownBehaviour = {
    init() {
        document.querySelectorAll('.js-dropdown:not([data-initialized="1"])').forEach(node => {
            this._createListeners(node);
        });
    },

    _createListeners(node) {
        let self = this;

        node.dataset.initialized = '1';
        let nodeButtons = node.querySelectorAll('.js-dropdown__button');
        nodeButtons.forEach(nodeButton => {
             nodeButton.addEventListener('click', self._toggleDropDown, null);
        });
    },

    _toggleDropDown() {
        if (this.querySelector('.icon-svg__icon-arrow-down svg')) {
            this.querySelector('.icon-svg__icon-arrow-down svg').classList.toggle('rotate');
        }

        let dropDownWrapper = this.closest('.js-dropdown__item').querySelector('.js-dropdown__item-inner-wrapper');
        dropDownWrapper.classList.toggle('hidden');
    },
};

dropDownBehaviour.init();

document.addEventListener('LokiRequestEnd', function () {
    dropDownBehaviour.init();
});
